require('../fhApp/currentUser/currentUser');

angular.module('app.changeEmail.changeEmailController', [
  'app.currentUser'
])
  .controller('app.changeEmail.changeEmailController', [
    '$scope',
    'currentUser',
    '$state',
    'appMetaService',
    function ($scope, currentUser, $state, appMeta) {
      "use strict";

      $scope.old_email = null;
      $scope.new_email = null;
      $scope.current_password = null;
      $scope.error = null;
      $scope.appMeta = appMeta;

      $scope.submitRequest = () => {
        currentUser.change_email($scope.old_email, $scope.new_email, $scope.current_password)
          .then((response) => {
            let data = response.data;

            if (data.error) {
              $scope.error = data.error;
            }
            if (data.email) {
              $state.go('app.changeEmail.sent', {email: data.email});
            }
          })
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/changeEmail/changeEmailController.js